module.exports = __webpack_public_path__ + "static/img/introduce_data02.b0cc39e4.png";